import { observer } from "mobx-react-lite"
import React, { useEffect, useRef } from "react"
import { AppState as NativeState, AppStateStatus } from "~/ui/primitives"
import { useStores } from "../../models"
import { AppState as AppStateProto, Event, EventNames } from "../../proto"
import { syncAppBadge } from "~services/jpush/badge"
// import { debug } from "../../utils"

const states = {
  active: AppStateProto.ACTIVE,
  inactive: AppStateProto.INACTIVE,
  background: AppStateProto.BACKGROUND,
}

// 将app的AppStateStatus转为后端的AppStateProto
const adaptor = (state: AppStateStatus): AppStateProto => {
  return states[state]
}

interface Props {}

const AppState: React.FC<Props> = () => {
  const appState = useRef<AppStateStatus>(NativeState.currentState)
  // const navigation = useNavigation()
  const rootStore = useStores()
  const { eventStore, setAppState, websocketStore, authStore } = rootStore
  useEffect(() => {
    const subscription = NativeState.addEventListener("change", _handleAppStateChange)
    return () => {
      subscription.remove()
    }
  }, [])
  const _handleAppStateChange = (nextAppState: AppStateStatus) => {
    // debug("nextAppState", nextAppState)
    // debug(`[AppState] ${appState.current} -> ${nextAppState}`)
    appState.current = nextAppState
    setAppState(nextAppState)
    eventStore.publish(
      new Event(EventNames.UPDATE_APP_STATE, {
        state: adaptor(nextAppState) ? adaptor(nextAppState) : nextAppState,
      }),
      {
        immediately: true,
      },
    )
    if (nextAppState === "background") {
      if (websocketStore.opened) {
        websocketStore.close()
      }
    } else if (nextAppState === "active") {
      if (!websocketStore.opened && authStore.token) {
        websocketStore.reconnect()
      }
      syncAppBadge(rootStore.messageStore.unread || 0)
    }
  }
  return null
}

export default observer(AppState)
